const Form = ({ children }) => {

    return (
        <form className='flx flx-column mg-left-lg mg-right-lg'>
            {children}
        </form>
    )
}

export default Form
